export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8258.87c0681d.jpg";